import { type BillingMethodListViewModel } from '@/features/billing/profile/BillingMethodList/BillingMethodListViewModel'
import { type ActivationLifecycle } from '@/infra/activation'
import { type NewBillingMethodDialogViewModel } from '@/features/billing/profile/NewBillingMethodDialog/NewBillingMethodDialogViewModel'
import { type TransactionsTableViewModel } from '@/features/billing/transactions/TransactionsTable/TransactionsTableViewModel'
import { LifecycleTracker } from '@/infra/lifecycle-tracker'
import { ModalViewModel } from '@/infra/ModalViewModel'
import { tapAction } from '@/utils/mobx-util'

export class PaymentsViewModel implements ActivationLifecycle {
  private readonly _lifecycle = new LifecycleTracker()

  /**
   * Dialog shown when a payment method has been created.
   */
  readonly successModal = new ModalViewModel()

  constructor(
    public readonly billingMethodsListVm: BillingMethodListViewModel,
    public readonly newBillingMethodDialogVm: NewBillingMethodDialogViewModel,
    public readonly transactionsTableVm: TransactionsTableViewModel,
  ) {
    this._lifecycle
      .manage(billingMethodsListVm)
      .manage(transactionsTableVm)
      // Show success dialog when a method has been created.
      .manage(
        this.newBillingMethodDialogVm.created$.pipe(
          tapAction(() => this.successModal.show()),
        ),
      )
  }

  activate() {
    this._lifecycle.activate()

    void this.billingMethodsListVm.fetchProfile(this._lifecycle.signal)
  }

  deactivate() {
    this._lifecycle.deactivate()
  }
}
